import { useState, useContext, useId } from "react";
import AppContext from '../../contexts/AppContext';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function CharacterSelecter({valueGetter}) {
  const [id, setId] = useState('');
  const controlId = useId();
  let {characters} = useContext(AppContext);


  let {setCharacter} = valueGetter




  const sortedCharacters = [...characters].sort((a,b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  })
  const characterMenu = sortedCharacters.map((char) => <MenuItem key={char.id} value={char.id}>{char.name}</MenuItem>)

  const handleChange = (event) => {
    setId(event.target.value);
    setCharacter(event.target.value)
  };




  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id={`${controlId}-label`}>Character</InputLabel>
        <Select
          labelId={`${controlId}-label`}
          id={controlId}
          value={id}
          label="Character"
          onChange={handleChange}
        >
          {characterMenu}
        </Select>
      </FormControl>
    </Box>
  );
}
